import { IonIcon, IonItem, IonLabel } from '@ionic/react'
import { icon_arrow_sx } from 'icons'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import IBackLinkProps from './back-link.interface'
import './back-link.scss'

const BackLink: React.FC<IBackLinkProps> = memo(({ text, link, onClick, style }) => {
  const { t } = useTranslation()

  return (
    <div className="back-link-component" style={style}>
      <IonItem lines="none" onClick={onClick}>
        <IonIcon icon={icon_arrow_sx} slot="start" />
        <IonLabel className="back-link">
          {!!link && <Link to={link}>{text ?? t('back')}</Link>}
          {!link && (text ?? t('back'))}
        </IonLabel>
      </IonItem>
    </div>
  )
})

export default BackLink
